import { Ng2StateDeclaration } from "@uirouter/angular";

export const settingsState: Ng2StateDeclaration = {
    name: "app.settings",
    url: "/settings",
    abstract: true
};


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/settings/settings.states.ts